export enum ItemArmorClass {
  light = "lekka",
  medium = "srednia",
  heavy = "ciezka",
}
